import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddCultureAction,
  UpdateCultureAction,
} from "store/middlewares/dataManagement/culture";
import { SubmitLoaderButton } from "components/atoms";

function ModalEditCulture({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    if (row) {
      dispatch(
        UpdateCultureAction({
          id: row.id,
          ...values,
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    } else {
      dispatch(
        AddCultureAction({
          ...values,
          filter: { page: 1, pageSize: 10 },
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      arName: row?.ar_name ? row?.ar_name : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Culture name is required"),
      arName: Yup.string().required("Culture name is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Culture</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name (English)</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter culture"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name (Arabic)</Label>
              <Input
                error={formik.errors.arName && formik.touched.arName}
                errorMsg={formik.errors.arName}
                value={formik.values.arName}
                type="text"
                name="arName"
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter culture"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              <SubmitLoaderButton
                type="submit"
                btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditCulture;
